import React from 'react';
import { Label } from '../atoms/label';
import { InputText } from '../atoms/inputText';
import useMedia from 'use-media';
export const LabelInputForm = (props) => {

    const isWideTablet = useMedia({ maxWidth: '960px' });
    const isWidePhone = useMedia({ maxWidth: '480px' });

    return (
        <div style={styles.content}>
            <Label label={props.label} style={props.style} />
            <InputText
                id={props.id}
                type={props.type}
                placeholder={props.placeholder}
                style={props.style2}
                maxLength={props.maxLength}
                value={props.value}
                onChange={props.onChange}
                class={props.class}
            />
        </div>
    );
}
const styles = {
    content: {
        textAlign: "left",
        width: "100%",
        marginBottom: 5,
        fontSize: "100%",
    },
}